module.exports = __webpack_public_path__ + "img/bx-grade-timetable.1b4a9360.svg";